import { gql } from "@apollo/client";

export default gql`
  query getLiveChatWidgetRelease($releaseId: ID!){
    getLiveChatWidgetRelease(releaseId: $releaseId){
        success
        data{
            _id
            version
            note
            status
            source
            restoredFrom
            bucket
            prefix
            archivePrefix
            distributionId
            cdnUrl
            files{
                path
                size
                contentType
            }
            removedKeys
            invalidationId
            invalidationStatus
            healthCheckUrl
            healthCheckStatus
            errorMessage
            publishedBy
            createdAt
            updatedAt
        }
        error
        message
    }
}
`
